import { useAccount } from "wagmi";
import wallet2 from "../../assets/images/wallet-add2.png";
// import { ConnectButton } from '@rainbow-me/rainbowkit';
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useEffect } from "react";

// import { ConnectButton } from "@rainbow-me/rainbowkit";

export default function WalletWrapper() {
  const { address } = useAccount();

  useEffect(() => {
   
  }, [address]);

 

  return (
    <>
      {/* <div className="cursor-pointer walletWrapper bg-[linear-gradient(180deg,_#C4FE481A_10%,_#C4FE481A_10%)] text-white max-w-90 whitespace-nowrap flax p-5 text-center rounded-md m-auto mt-10">
        <button className="flax w-1/3 h-5 mx-auto flex items-center justify-center text-lime-300">
          <img alt="" src={wallet2} className="p-1 float-left" />
          Connect Wallet
        </button>
        {/* <ConnectButton /> */}
      
          {/* </div> */} 
          <div className="flex center w-full justify-center items-center \">
  <ConnectButton.Custom>
    {({
      account,
      chain,
      openAccountModal,
      openChainModal,
      openConnectModal,
      mounted,
    }) => {
      const ready = mounted;
      const connected = ready && account && chain;

      return (
        <div
          {...(!ready && {
            'aria-hidden': true,
            className: 'opacity-0 pointer-events-none select-none',
          })}
        >
          {(() => {
            if (!connected) {
              return (
                <div className="cursor-pointer walletWrapper bg-[linear-gradient(180deg,_#C4FE481A_10%,_#C4FE481A_10%)] text-white max-w-90 whitespace-nowrap flax p-5 text-center rounded-md m-auto mt-10">
        <button 
        onClick={openConnectModal}
                  type="button"
        className="flax w-1/3 h-5 mx-auto flex items-center justify-center text-lime-300">
          <img alt="" src={wallet2} className="p-1 float-left" />
          Connect Wallet
        </button>
        {/* <ConnectButton /> */}
      
          </div>
              );
            }

            if (chain.unsupported) {
              return (
                <button
                  onClick={openChainModal}
                  type="button"
                  className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
                >
                  Wrong network
                </button>
              );
            }

            return (
              <div className="flex gap-3">
                <button
                  onClick={openChainModal}
                  type="button"
                  className="flex items-center bg-[#383937] hover:bg-gray-700 text-white py-2 px-4 rounded "
                >
                  {chain.hasIcon && (
                    <div
                      className="bg-white w-3 h-3 rounded-full overflow-hidden mr-2"
                      style={{ background: chain.iconBackground }}
                    >
                      {chain.iconUrl && (
                        <img
                          alt={chain.name ?? 'Chain icon'}
                          src={chain.iconUrl}
                          className="w-3 h-3"
                        />
                      )}
                    </div>
                  )}
                  {chain.name}
                </button>
                <button
                  onClick={openAccountModal}
                  type="button"
                  className="hover:bg-[#acdf3d] bg-[#C4FE48] text-black  py-2 px-4 rounded "
                >
                  {account.displayName}
                  {account.displayBalance
                    ? ` (${account.displayBalance})`
                    : ''}
                </button>
              </div>
            );
          })()}
        </div>
      );
    }}
  </ConnectButton.Custom>
  </div>
    </>
  );
}